export default {
  text: '#474747',
  primary: '#634a3d',
  secondary: '#f7d23b',
  background: '#f8f8f8',
  backgroundSecondary: '#f1f1f1',
  light: '#f8f8f8',
  dark: '#000000'
}
